import sellCarQuestionnaireConfig from "../../au.desktop/config/sell-car-config";
import sellCarQuestionnaireConfigMsite from "../../au.mobile/config/sell-car-config";

export const getQuestionnarieConfigDesktop = () => {
    return sellCarQuestionnaireConfig;
};

export const getQuestionnarieConfigMsite = () => {
    return sellCarQuestionnaireConfigMsite;
};
